import { cdn } from "constants/common";
import { Check, X, XIcon } from "lucide-react";
import moment from "moment";
import React from "react";
import RejectSubmissionModal from "./RejectSubmissionModal";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { usePermissions } from "layouts/Admin";
import { useSelector } from "react-redux";
import { userSelector } from "slices/userSlice";

const TranslatedDocumentsTable = ({
  item,
  onApproveSubmmision,
  callViewApi,
}) => {
  const [cancelModal, setCancelModal] = React.useState(false);
  const [cancelTransId, setCancelTransId] = React.useState(null);
  const [rejectionModal, setRejectionModal] = React.useState({
    show: false,
    reason: "",
  });

  const onView = ({ reason }) => {
    setRejectionModal({
      show: true,
      reason,
    });
  };

  // console.log("rejectItem", item);

  const renderTableHeader = React.useCallback(() => {
    return (
      <>
        <tr>
          <th className="table-col">Doc Name</th>
          <th className="table-col">Uploaded By</th>
          <th className="table-col">Uploaded At</th>
          <th className="table-col">Status</th>
          <th className="table-col">Approved/Rejected By</th>
          <th className="table-col">Approved/Rejected At</th>
          <th className="table-col">Reason</th>
          <th className="table-col">Actions</th>
        </tr>
      </>
    );
  }, []);

  const renderTableContent = React.useCallback(
    (key, arr) => {
      return (
        <LogItem
          item={arr}
          key={key}
          id={item?.id}
          status={item?.status}
          onView={onView}
          cancelModal={cancelModal}
          setCancelTransId={setCancelTransId}
          setCancelModal={setCancelModal}
          onApproveSubmmision={onApproveSubmmision}
        />
      );
    },
    [cancelModal, item?.id, item?.status, onApproveSubmmision]
  );
  const handleSubmit = () => {};
  const handleCloseCancel = () => {
    setCancelModal(false);
    setCancelTransId(null);
  };
  return (
    <>
      <RejectSubmissionModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        transId={cancelTransId}
        callViewApi={callViewApi}
      />

      {/* Reject Reason Modal  */}
      {rejectionModal.show && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Rejection Reason</h5>
                <XIcon
                  className="cursor-pointer"
                  onClick={() => setRejectionModal({ show: false, reason: "" })}
                />
              </div>
              <div className="modal-body">
                <p>{rejectionModal.reason || "No reason provided."}</p>
              </div>

              <div className="modal-footer">
                <SubmitButton
                  btnText="Close"
                  buttonType="button"
                  handleSubmit={() =>
                    setRejectionModal({ show: false, reason: "" })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="table_responsive">
        <table className="table">
          <thead className="text-primary">{renderTableHeader()}</thead>
          <tbody>
            {item?.translation_translated_files &&
              item?.translation_translated_files?.map((item, key) =>
                renderTableContent(key, item)
              )}
          </tbody>
        </table>
      </div>
    </>
  );
};

const LogItem = ({
  item,
  onApproveSubmmision,
  status,
  setCancelModal,
  setCancelTransId,
  id,
  cancelModal,
  onView,
}) => {
  console.log("id", id);
  const { checkPermission } = usePermissions();
  const { user } = useSelector(userSelector);
  const role = user?.role ?? user?.user?.role;
  const uploadedAt = moment(item?.created_at).format("MMM D, YYYY HH:mm:ss");
  let action_at;
  if (item?.approved_at) {
    action_at = item?.approved_at
      ? moment(item?.approved_at).format("MMM D, YYYY HH:mm:ss")
      : "N/A";
  } else if (item?.rejected_at) {
    action_at = item?.rejected_at
      ? moment(item?.rejected_at).format("MMM D, YYYY HH:mm:ss")
      : "N/A";
  }
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: "#f4f4f4" } : {};
  };

  return (
    <tr>
      <td className="table-col">
        {role === "subuser"
          ? checkPermission("Download Translated Documents")
            ? (
                <a href={cdn + item?.file_path} target="_blank" rel="noreferrer noopener">
                  {item?.file_name || "N/A"}
                </a>
              )
            : (
                item?.file_name || "N/A"
              )
          : (
              <a href={cdn + item?.file_path} target="_blank" rel="noreferrer noopener">
                {item?.file_name || "N/A"}
              </a>
            )}
      </td>
      <td className="table-col">{item?.uploaded_by?.name}</td>
      <td className="table-col">{uploadedAt ?? "N/A"}</td>
      <td className="table-col">{item?.status}</td>
      <td className="table-col">
        {item?.approved_by?.name || item?.rejected_by?.name}
      </td>
      <td className="table-col">{action_at}</td>

      <td>
        {item?.status === "Rejected" && (
          <div>
            <div
              className="cursor-pointer"
              onClick={() =>
                onView({
                  reason: item?.rejection_reason || "No reason provided",
                })
              }
            >
              <i className="fa-solid fa-eye"></i>
            </div>
          </div>
        )}
      </td>

      <td className="table-col" style={getBackgroundStyle(status)}>
        {item?.status == "Under Review" && status == "Under Review" && (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {(role === "subuser" ? checkPermission("Approve Translated Documents") : true) && (
              <button
                onClick={onApproveSubmmision}
                type="danger"
                style={{
                  backgroundColor: "green",
                  borderRadius: "50%",
                  border: "none",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <Check color="#FFF" size={20} />
              </button>
            )}
            {(role === "subuser" ? checkPermission("Reject Translated Documents") : true) && (
              <button
                onClick={() => {
                  setCancelModal(true);
                  setCancelTransId && setCancelTransId(id);
                }}
                type="danger"
                style={{
                  backgroundColor: "red",
                  borderRadius: "50%",
                  border: "none",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <X color="#FFF" size={20} />
              </button>
            )}
          </div>
        )}
      </td>

      {/* <td className="col-2">
        {item?.status == 'Under Review' && status == 'Under Review' &&
        <div className="d-flex justify-content-between align-items-end flex-column">
          <SubmitButton
            buttonType="button"
            className={"tomatoRed"}
            btnText="Reject Submission"
            handleSubmit={onApproveSubmmision}
            style={{fontSize:'12px',marginBottom:'2px'}}
          />
          <SubmitButton
            buttonType="button"
            className={"seagreen"}
            btnText="Approve Submission"
            handleSubmit={onApproveSubmmision}
            style={{fontSize:'12px'}}
          />
          </div>
        }
      </td> */}
    </tr>
  );
};
export default TranslatedDocumentsTable;
